(() => {
  const colours = window.CS_COLOURS || [];

  function createColourButton(colour, panelId) {
    const button = document.createElement("button");

    const ralMatch = colour.colour.match(/\bRAL\s*(\d{4})\b/i);
    const cedralMatch = colour.colour.match(/^C\d{2}\b/i);

    const isCedral =
      colour.range === "cladding" && Boolean(cedralMatch);

    const isCladco =
      colour.range === "cladding" &&
      !ralMatch &&
      !isCedral;

    let displayName = colour.colour;

    if (isCedral) {
      displayName = `CEDRAL ${colour.colour}`;
    } else if (isCladco) {
      displayName = `CLADCO ${colour.colour}`;
    }

    button.type = "button";
    button.className = "cs-colour-card";
    button.dataset.csColour = colour.colour;
    button.dataset.csLabel = displayName;
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-controls", panelId);
    button.setAttribute(
      "aria-label",
      `View products available in ${displayName}`
    );

    const swatch = document.createElement("span");
    swatch.className = "cs-colour-card__swatch";
    swatch.style.backgroundColor = colour.hex;

    const label = document.createElement("span");
    label.className = "cs-colour-card__label";

    if (ralMatch) {
      const ralText = document.createElement("span");
      ralText.textContent = "RAL";

      const ralNumber = document.createElement("span");
      ralNumber.textContent = ralMatch[1];

      label.append(ralText, ralNumber);
    } else if (isCedral) {
      const brandText = document.createElement("span");
      brandText.textContent = "CEDRAL";

      const colourText = document.createElement("span");
      colourText.textContent = colour.colour;

      label.append(brandText, colourText);
    } else if (isCladco) {
      const brandText = document.createElement("span");
      brandText.textContent = "CLADCO";

      const colourText = document.createElement("span");
      colourText.textContent = colour.colour;

      label.append(brandText, colourText);
    } else {
      label.textContent = displayName;
    }

    button.append(swatch, label);

    return button;
  }

  function findLastButtonInRow(grid, selectedButton) {
    const buttons = Array.from(
      grid.querySelectorAll("[data-cs-colour]")
    );

    const selectedTop = selectedButton.offsetTop;

    const buttonsInRow = buttons.filter(
      (button) => button.offsetTop === selectedTop
    );

    return buttonsInRow[buttonsInRow.length - 1];
  }

  function createContactUrl(selectedLabel, requestType) {
    const contactUrl = new URL(
      "/pages/contact-us",
      window.location.origin
    );

    contactUrl.searchParams.set("colour", selectedLabel);
    contactUrl.searchParams.set("request", requestType);

    return contactUrl.pathname + contactUrl.search;
  }

  function initialiseColourBrowser(browser, browserIndex) {
    const collectionUrl = browser.dataset.collectionUrl;

    if (!collectionUrl) {
      console.error("Colour browser: collection URL is missing.");
      return;
    }

    const panelId = `cs-colour-panel-${browserIndex}`;
    const panel = document.createElement("div");

    panel.id = panelId;
    panel.className = "cs-colour-panel";
    panel.hidden = true;
    panel.setAttribute("role", "region");
    panel.setAttribute("aria-live", "polite");

    let activeButton = null;
    let requestNumber = 0;

    const cache = new Map();

    browser
      .querySelectorAll("[data-cs-colour-grid]")
      .forEach((grid) => {
        const range = grid.dataset.range;

        colours
          .filter((colour) => colour.range === range)
          .forEach((colour) => {
            const button = createColourButton(colour, panelId);

            grid.appendChild(button);

            button.addEventListener("click", async () => {
              if (activeButton === button && !panel.hidden) {
                button.setAttribute("aria-expanded", "false");
                panel.hidden = true;
                panel.remove();
                activeButton = null;
                return;
              }

              if (activeButton) {
                activeButton.setAttribute(
                  "aria-expanded",
                  "false"
                );
              }

              activeButton = button;
              button.setAttribute("aria-expanded", "true");

              panel.remove();
              panel.hidden = false;
              panel.innerHTML =
                '<p class="cs-colour-panel__loading">Loading products…</p>';

              const lastButton = findLastButtonInRow(
                grid,
                button
              );

              lastButton.insertAdjacentElement(
                "afterend",
                panel
              );

              const selectedColour =
                button.dataset.csColour;

              const selectedLabel =
                button.dataset.csLabel || selectedColour;

              const filteredUrl = new URL(
                collectionUrl,
                window.location.origin
              );

              filteredUrl.searchParams.set(
                "filter.v.option.colour",
                selectedColour
              );

              filteredUrl.searchParams.set(
                "sort_by",
                "best-selling"
              );

              const sectionUrl = new URL(filteredUrl);

              sectionUrl.searchParams.set(
                "section_id",
                "colour-product-links"
              );

              const currentRequest = ++requestNumber;
              const cacheKey = sectionUrl.toString();

              try {
                let productHtml = cache.get(cacheKey);

                if (!productHtml) {
                  const response = await fetch(
                    sectionUrl.toString(),
                    {
                      headers: {
                        "X-Requested-With": "XMLHttpRequest"
                      }
                    }
                  );

                  if (!response.ok) {
                    throw new Error(
                      `Request failed: ${response.status}`
                    );
                  }

                  productHtml = await response.text();
                  cache.set(cacheKey, productHtml);
                }

                if (
                  currentRequest !== requestNumber ||
                  activeButton !== button
                ) {
                  return;
                }

                panel.innerHTML = productHtml;

                const results = panel.querySelector(
                  "[data-cs-product-results]"
                );

                if (!results) {
                  throw new Error(
                    "Product results were missing."
                  );
                }

                const productCount = Number(
                  results.dataset.productCount || 0
                );

                const hasProducts = productCount > 0;

                const actions = document.createElement("div");
                actions.className =
                  "cs-colour-panel__actions";

                if (hasProducts) {
                  const allProductsLink =
                    document.createElement("a");

                  allProductsLink.className =
                    "cs-colour-panel__all-products";

                  allProductsLink.href =
                    filteredUrl.pathname +
                    filteredUrl.search;

                  const ralButtonMatch = selectedColour.match(
                    /\bRAL\s*(\d{4})\b/i
                  );

                  const shortColourLabel = ralButtonMatch
                    ? `RAL ${ralButtonMatch[1]}`
                    : selectedLabel;

                  allProductsLink.textContent =
                    `View all products in ${shortColourLabel}`;

                  const customScrewLink =
                    document.createElement("a");

                  customScrewLink.className =
                    "cs-colour-panel__custom-request";

                  customScrewLink.href = createContactUrl(
                    selectedLabel,
                    "custom-screw"
                  );

                  customScrewLink.textContent =
                    "Order this colour on a another screw";

                  actions.append(
                    allProductsLink,
                    customScrewLink
                  );
                } else {
                  actions.classList.add(
                    "cs-colour-panel__actions--single"
                  );
                  
                  const requestColourLink =
                    document.createElement("a");

                  requestColourLink.className =
                    "cs-colour-panel__all-products cs-colour-panel__request-colour";

                  requestColourLink.href = createContactUrl(
                    selectedLabel,
                    "custom-colour"
                  );

                  requestColourLink.textContent =
                    `Request ${selectedLabel}`;

                  actions.appendChild(requestColourLink);
                }

                panel.appendChild(actions);
              } catch (error) {
                console.error(error);

                panel.innerHTML =
                  '<p class="cs-colour-panel__error">Products could not be loaded. Please try again.</p>';
              }
            });
          });
      });

    window.addEventListener("resize", () => {
      if (!activeButton || panel.hidden) return;

      panel.remove();

      const grid = activeButton.closest(
        "[data-cs-colour-grid]"
      );

      const lastButton = findLastButtonInRow(
        grid,
        activeButton
      );

      lastButton.insertAdjacentElement(
        "afterend",
        panel
      );
    });
  }

  function startColourBrowsers() {
    document
      .querySelectorAll("[data-cs-colour-browser]")
      .forEach(initialiseColourBrowser);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startColourBrowsers
    );
  } else {
    startColourBrowsers();
  }
})();